export const StatutsDemande = {
  ENCOURS: 'ENCOURS',
  VALIDEE: 'VALIDEE',
  REFUSEE: 'REFUSEE',
};
